<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}">
						<h4 class="card-title" id="headof" (click)="back()"><i class="material-icons">arrow_left</i> Find Document</h4>
						<p class="card-category">Trace a document number across AR, AP and the GL</p>
					</div>
					<div class="card-body">
						<form [formGroup]="formGroup" (ngSubmit)="search()">
							<div class="row">
								<div class="col-md-8">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Document number</mat-label>
										<input matInput type="text" inputmode="numeric" formControlName="number" placeholder="e.g. 1213765" autocomplete="off">
									</mat-form-field>
								</div>
								<div class="col-md-4 text-right">
									<button class="mt-2" mat-raised-button color="accent" type="submit">Search</button>
								</div>
							</div>
						</form>

						<div class="col-md-12 text-center" *ngIf="isrunning">
							<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
							</svg>
						</div>

						<ng-container *ngIf="searched && !isrunning && results">
							<h4 *ngIf="totalHits() === 0" class="text-left mt-3">No document found for "{{ results.number }}".</h4>

							<!-- AR -->
							<div class="dl-section" *ngIf="results.counts?.ar">
								<h4 class="bold">Accounts Receivable <span class="dl-count">({{ results.counts.ar }})</span></h4>
								<div class="table-responsive">
									<table class="table">
										<thead>
											<tr>
												<th>Type</th>
												<th>Number</th>
												<th>Date</th>
												<th>Customer</th>
												<th>Branch</th>
												<th>Reference</th>
												<th class="text-right">Total</th>
												<th class="text-right">Allocated</th>
												<th>Settled</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let r of results.ar" class="clickable-row" (click)="openCustomer(r.debtorno)">
												<td>{{ r.typename }}</td>
												<td>{{ r.transno }}</td>
												<td>{{ r.trandate }}</td>
												<td>{{ r.debtorno }}<span *ngIf="r.partyname"> — {{ r.partyname }}</span></td>
												<td>{{ r.branchcode }}</td>
												<td>{{ r.reference }}</td>
												<td class="text-right">{{ r.total | currency }}</td>
												<td class="text-right">{{ r.alloc | currency }}</td>
												<td>{{ r.settled == 1 ? 'Yes' : 'No' }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>

							<!-- AP -->
							<div class="dl-section" *ngIf="results.counts?.ap">
								<h4 class="bold">Accounts Payable <span class="dl-count">({{ results.counts.ap }})</span></h4>
								<div class="table-responsive">
									<table class="table">
										<thead>
											<tr>
												<th>Type</th>
												<th>Number</th>
												<th>Date</th>
												<th>Vendor</th>
												<th>Reference</th>
												<th class="text-right">Total</th>
												<th class="text-right">Allocated</th>
												<th>Settled</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let r of results.ap" class="clickable-row" (click)="openVendor(r.supplierno)">
												<td>{{ r.typename }}</td>
												<td>{{ r.transno }}</td>
												<td>{{ r.trandate }}</td>
												<td>{{ r.supplierno }}<span *ngIf="r.partyname"> — {{ r.partyname }}</span></td>
												<td>{{ r.suppreference }}</td>
												<td class="text-right">{{ r.total | currency }}</td>
												<td class="text-right">{{ r.alloc | currency }}</td>
												<td>{{ r.settled == 1 ? 'Yes' : 'No' }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>

							<!-- GL -->
							<div class="dl-section" *ngIf="results.counts?.gl">
								<h4 class="bold">General Ledger <span class="dl-count">({{ results.counts.gl }})</span></h4>
								<div class="table-responsive">
									<table class="table">
										<thead>
											<tr>
												<th>Type</th>
												<th>Number</th>
												<th>Date</th>
												<th>Account</th>
												<th>Narrative</th>
												<th class="text-right">Debit</th>
												<th class="text-right">Credit</th>
												<th>Posted</th>
												<th>Tag</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let r of results.gl" class="clickable-row" (click)="openGlAccount(r.account)">
												<td>{{ r.typename }}</td>
												<td>{{ r.typeno }}</td>
												<td>{{ r.trandate }}</td>
												<td>{{ r.account }}<span *ngIf="r.accountname"> — {{ r.accountname }}</span></td>
												<td>{{ r.narrative }}</td>
												<td class="text-right">{{ r.debit ? (r.debit | currency) : '' }}</td>
												<td class="text-right">{{ r.credit ? (r.credit | currency) : '' }}</td>
												<td>{{ r.posted == 1 ? 'Yes' : 'No' }}</td>
												<td>{{ r.tag }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
